/** Breite des Containers in Spielpixeln: Minecraft-Inventare sind immer 176 breit. */
export function inventarBreite(_spalten: number): number {
  return 176;
}

export const SLOT = 18;

/** Viertelschritte zwischen 1 und 2, damit Pixelkanten ruhig bleiben. */
export function skalierung(verfuegbarPx: number, spalten: number): number {
  const s = Math.floor((verfuegbarPx / inventarBreite(spalten)) * 4) / 4;
  return Math.max(1, Math.min(2, s));
}

/** Linke Kante des Slotrasters je Form, wie im Spiel zentriert. */
export function rasterLinks(spalten: number): number {
  return spalten === 9 ? 7 : Math.round((176 - spalten * SLOT) / 2);
}
